import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

export type ChangeRequestField = 'message' | 'customerName' | 'customerEmail' | 'customerPhone';
export type ChangeRequestErrors = Partial<Record<ChangeRequestField, string>>;

export function validateChangeMessage(value: string) {
  const normalized=value.trim();
  if(!normalized)return 'Describe what you would like changed.';
  if(normalized.length<5)return 'Add a little more detail—at least 5 characters.';
  if(normalized.length>5000)return 'Keep the request under 5,000 characters.';
  return '';
}

export function validateCustomerName(value: string) {
  const normalized=value.trim();
  if(!normalized)return 'Enter your name.';
  if(normalized.length<2)return 'Name must contain at least 2 characters.';
  if(normalized.length>100)return 'Name must be 100 characters or fewer.';
  if(!/\p{L}/u.test(normalized))return 'Enter a name containing at least one letter.';
  return '';
}

export function validateCustomerEmail(value: string) {
  const normalized=value.trim();
  if(!normalized)return 'Enter your email address.';
  if(normalized.length>254)return 'Email address must be 254 characters or fewer.';
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u.test(normalized))return 'Enter a valid email address, such as name@example.com.';
  return '';
}

export function validateCustomerPhone(value: string) {
  const normalized=value.trim();
  if(!normalized)return 'Enter your phone number.';
  const phone=parsePhoneNumberFromString(normalized,'US');
  if(!phone?.isPossible())return 'Enter a complete phone number. International numbers must start with + and a country code.';
  return '';
}

export function validateContactDetails(values:{customerName:string;customerEmail:string;customerPhone:string}):ChangeRequestErrors {
  const errors:ChangeRequestErrors={};
  const nameError=validateCustomerName(values.customerName);
  const emailError=validateCustomerEmail(values.customerEmail);
  const phoneError=validateCustomerPhone(values.customerPhone);
  if(nameError)errors.customerName=nameError;
  if(emailError)errors.customerEmail=emailError;
  if(phoneError)errors.customerPhone=phoneError;
  return errors;
}
